module.exports = __webpack_public_path__ + "static/img/Bitmap_4.59c08c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Bitmap_4.jpg
// module id = pdS4
// module chunks = 3